export default __webpack_public_path__ + "static/media/logo-two.98ea6ef2.png";